import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const CommentChatIcon: React.FC<IconProps> = ({
  viewBox = ICON_VIEWBOX.medium,
  color = 'currentColor',
  size = ICON_SIZE.medium,
  fillOpacity,
}) => (
  <SvgWrapper aria-label="Chat comment" viewBox={viewBox} size={size}>
    <path
      d="M12 2C9.34783 2 6.8043 3.05357 4.92893 4.92893 3.05357 6.8043 2 9.34783 2 12c0 1.5498.35979 3.0626 1.03304 4.4265l-.87917 5.4146 5.45072-.8588C8.96039 21.6457 10.4619 22 12 22c2.6522 0 5.1957-1.0536 7.0711-2.9289C20.9464 17.1957 22 14.6522 22 12c0-2.65217-1.0536-5.1957-2.9289-7.07107C17.1957 3.05357 14.6522 2 12 2Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  </SvgWrapper>
)

export default CommentChatIcon
